export default "__VITE_ASSET__Dtsj_5ZF__"